// HomesPulse shared helpers + brand tokens

export const HP = {
  pine: "#0F172A",
  pineDeep: "#0F172A",
  coral: "#2563EB",
  coralDeep: "#1D4ED8",
  sand: "#F8FAFC",
  ink: "#334155",
};

export const fmtPrice = (n, rent) => {
  if (n == null) return "—";
  return `$${Number(n).toLocaleString()}${rent ? "/mo" : ""}`;
};

export const fmtNum = (n) => (n == null ? "—" : Number(n).toLocaleString());

// Photos may be stored as objects ({image_url, thumb_url}) for seeded sample data
// or as plain URL strings for user-submitted listings. Normalise both.
export const photoSrc = (p, thumb) => {
  if (!p) return null;
  if (typeof p === "string") return p;
  return thumb ? (p.thumb_url || p.image_url) : (p.image_url || p.thumb_url);
};

export const TYPE_LABEL = {
  single_family: "Single Family",
  condo: "Condo",
  townhouse: "Townhouse",
  multifamily: "Multi-Family",
  new_construction: "New Construction",
  land: "Land",
  apartment: "Apartment",
};

export const typeLabel = (t) => TYPE_LABEL[t] || (t || "").replace(/_/g, " ");

export const PROPERTY_TYPES = [
  { v: "", label: "Any type" },
  { v: "single_family", label: "Single Family" },
  { v: "condo", label: "Condo" },
  { v: "townhouse", label: "Townhouse" },
  { v: "multifamily", label: "Multi-Family" },
  { v: "new_construction", label: "New Construction" },
  { v: "apartment", label: "Apartment" },
  { v: "land", label: "Land" },
];
